import React from 'react';
import SearchIcon from './search-icon.svg';
import * as S from './SearchBar.style';
export const SearchBar = ({ value, placeholder, disabled, labelName, error, message = '', ...rest }) => (React.createElement(S.SearchBar, null,
    React.createElement(S.Label, { htmlFor: labelName }, labelName),
    React.createElement(S.SearchIcon, null,
        React.createElement("img", { width: '24', height: '24', src: SearchIcon, alt: '' })),
    React.createElement(S.Input, Object.assign({ type: 'text', id: labelName, name: labelName, value: value, disabled: disabled, placeholder: placeholder, error: !!error }, rest))));
//# sourceMappingURL=SearchBar.js.map